import styled from '@xstyled/styled-components';

export const ItemTime = styled.small`
  color: greyDark;
`;
